import { ConnectionDetails, convertConnectionToDetails, mergeConnectionDetails as merge } from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  AccidentIssueDocument,
  AccidentIssueDocumentSearch,
  SearchAccidentIssueDocumentResponseAccidentIssueDocumentConnectionArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { SearchAccidentIssueDocument } from '@/features/AccidentHistory/api/queries/SearchAccidentIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof AccidentIssueDocumentSearch]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<AccidentIssueDocument>>;
}

// SearchAccidentIssueDocument Service
export const { searchAccidentIssueDocument, refetchAccidentIssueDocument, useAccidentIssueDocument } = ((): {
  searchAccidentIssueDocument: ServiceMethod;
  refetchAccidentIssueDocument: ServiceMethod;
  useAccidentIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchAccidentIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<AccidentIssueDocument>> => {
        const args: SearchAccidentIssueDocumentResponseAccidentIssueDocumentConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? 'searchAccidentIssueDocument.accidentIssueDocumentConnection' : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty('searchAccidentIssueDocument.accidentIssueDocumentConnection', res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchAccidentIssueDocument: fetch,
    refetchAccidentIssueDocument: refetch,
    useAccidentIssueDocument: useService,
  };
})();
